import * as luckyDrawReport from '../services/report.js';

export default {
  namespace: 'luckyDrawReport',
  state: {},
  effects: {
    //抽奖活动报表数据
    *getLotteryReport({ payload: { values }, callback }, { call, put }) {
      const response = yield call(luckyDrawReport.getLotteryReport, values);
      yield put({
        type: 'save',
        payload: {
          lotteryReportData: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (props.pathname.includes('/luck_draw_view_report')) {
          dispatch({
            type: 'save',
            payload: {
              lotteryReportData: {},
            },
          });
        }
      });
    },
  },
};
